<template>
  <div>
    <form-field-currency
      label="After Repair Value"
      v-model="form.after_repair_value"
      :validation-errors="validationErrors.after_repair_value"
    ></form-field-currency>

    <form-field-input
      label="Offer Percentage"
      v-model="form.offer_percentage"
      :validation-errors="validationErrors.offer_percentage"
    >
      <template v-slot:after>
        <p class="control">
          <span class="button is-small field-button">%</span>
        </p>
      </template>
    </form-field-input>

    <form-field-currency
      label="Repair Costs"
      v-model="form.repair_costs"
      :validation-errors="validationErrors.repair_costs"
    ></form-field-currency>

    <form-field-currency
      label="Other Costs"
      v-model="form.other_costs"
      :validation-errors="validationErrors.other_costs"
    ></form-field-currency>

    <form-field-currency
      label="Desired Wholesale Fee"
      v-model="form.desired_wholesale_fee"
      :validation-errors="validationErrors.desired_wholesale_fee"
    ></form-field-currency>

    <hr>

    <p class="mao_value">Max Allowable Offer <span>{{ $utils.formatCurrency(maxAllowableOffer, 0) }}</span></p>
  </div>
</template>

<script>
  import {FormMixin} from "./forms.mixin";

  export default {
    name: "WholesaleAnalysisForm",
    props: ['formData'],
    mixins: [FormMixin],
    data() {
      return {
        form: {},
        validationErrors: {},
        defaultForm: {
          record_id: this.$store.state.activeRecord.record.id,
          after_repair_value: null,
          offer_percentage: null,
          repair_costs: null,
          other_costs: null,
          desired_wholesale_fee: null,
        },
      }
    },
    created() {
      // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
      this.form = (this.formData && this.formData.id) ? this.$utils.clone(this.formData) : this.$utils.clone({...this.defaultForm, ...this.formData});

      // Set a default offer percentage if there isn't one already
      if(!this.form.offer_percentage) {
        this.form.offer_percentage = 70;
      }
    },
    computed: {
      worth() {
        // these are null by default instead of 0 so the UI is easier to use, but for calculations I need them to be 0
        let repairCosts = this.form.repair_costs ? this.form.repair_costs : 0;
        let otherCosts = this.form.other_costs ? this.form.other_costs : 0;
        let afterRepairValue = this.form.after_repair_value ? this.form.after_repair_value : 0;
        let offerPercentage = this.form.offer_percentage ? this.form.offer_percentage : 0;

        const totalCosts = parseFloat(repairCosts) + parseFloat(otherCosts);
        const value = parseFloat(afterRepairValue) * (parseFloat(offerPercentage) / 100);

        return value - totalCosts;
      },
      maxAllowableOffer() {
        let desiredWholesaleFee = this.form.desired_wholesale_fee ? this.form.desired_wholesale_fee : 0;

        return this.worth - parseFloat(desiredWholesaleFee);
      },
    },
    methods: {
      update() {
        this.form.maximum_allowable_offer = this.maxAllowableOffer;

        return this.$api.analysis.updateWholesaleAnalyses(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Analysis was updated',
              type: 'is-success'
            });

            return res;
          })
        },
      create() {
        this.form.maximum_allowable_offer = this.maxAllowableOffer;

        return this.$api.analysis.createWholesaleAnalyses(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Analysis was created',
              type: 'is-success'
            });

            return res;
          })
        },
      // delete() {
      //   return this.$api.wholesaleAnalyses.delete(this.form.id)
      //     .then(res => {
      //       this.$buefy.toast.open({
      //         message: 'Analysis was archived',
      //         type: 'is-success'
      //       });
      //
      //       return res;
      //     });
      // },
      // restore() {
      //   return this.$api.wholesaleAnalyses.restore(this.form.id)
      //     .then(res => {
      //       this.$buefy.toast.open({
      //         message: 'Analysis was restored',
      //         type: 'is-success'
      //       });
      //
      //       return res;
      //     });
      // },
    },
  }
</script>

<style lang="scss" scoped>
@import "../styles/variables/variables";

.mao_value {

  span {
    float: right;
  }
}
</style>
